import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import useMinimumSale from "../CustomHooks/useMinimumSale";
import MinimumsTable from "../MinimumSales/MinimumSaleTable";
import { useCurrencyFormatter } from "../CustomHooks/useCurrencyFormatter";
import ClearIcon from "@mui/icons-material/Clear";
import InputAdornment from "@mui/material/InputAdornment";
import ReplayIcon from "@mui/icons-material/Replay";
import { Stack } from "@mui/material";

const MinimumSaleTab = () => {
  const { formatCurrency } = useCurrencyFormatter();
  const {
    imputations,
    minimumSale,
    loading,
    fetchMinimumSale,
    fetchImputations,
    fetchDrawSettlementDate,
    drawSettlementDate,
    selectedDate,
    setSelectedDate,
    selectedImputation,
    setSelectedImputation,
    agencySelected,
    filteredImputations,
    filteredDates,
    clearFilters,
    error,
    exportMinimumSaleData,
    exporting
  } = useMinimumSale();

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2, justifyContent: "center" }}>
        <Grid item xs={12} sx={{ mt: 5 }}>
          <Box sx={{ xs: "column", sm: "row" }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={3}
              justifyContent="center"
              alignItems="center"
              divider={<Box sx={{ width: 24 }} />} // Espacio visual entre grupos
            >
              <Stack direction="row" spacing={2}>
                {/* SELECT DE FECHA DE LIQUIDACIÓN */}
                <FormControl size="medium" sx={{ minWidth: 180 }}>
                  <InputLabel>Fecha de Liquidación</InputLabel>
                  <Select
                    value={selectedDate || ""}
                    label="Fecha de Liquidación"
                    onChange={(e) => {
                      setSelectedDate(e.target.value);
                    }}
                    endAdornment={
                      selectedDate && (
                        <InputAdornment
                          position="end"
                          sx={{ cursor: "pointer" }}
                        >
                          <ClearIcon
                            fontSize="small"
                            onClick={() => {
                              clearFilters();
                            }}
                          />
                        </InputAdornment>
                      )
                    }
                  >
                    {(filteredDates || drawSettlementDate)?.length === 0 ? (
                      <MenuItem disabled>No hay fechas disponibles</MenuItem>
                    ) : (
                      (filteredDates || drawSettlementDate)?.map((date) => (
                        <MenuItem key={date.id} value={date.id}>
                          {date.label}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
                {/* SELECT DE IMPUTACIONES */}
                <FormControl size="medium" sx={{ minWidth: 180 }}>
                  <InputLabel>Imputación</InputLabel>
                  <Select
                    value={selectedImputation}
                    label="Imputación"
                    onChange={(e) => {
                      setSelectedImputation(e.target.value);
                    }}
                    endAdornment={
                      selectedImputation && (
                        <InputAdornment
                          position="end"
                          sx={{ cursor: "pointer" }}
                        >
                          <ClearIcon
                            fontSize="small"
                            onClick={() => {
                              clearFilters();
                            }}
                          />
                        </InputAdornment>
                      )
                    }
                  >
                    {(filteredImputations || imputations)?.length === 0 ? (
                      <MenuItem disabled>
                        No hay imputaciones disponibles
                      </MenuItem>
                    ) : (
                      (filteredImputations || imputations)?.map((imp) => (
                        <MenuItem key={imp.id} value={imp.id}>
                          {imp.label}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={2}>
                {/* BOTÓN DE CONSULTA */}
                <Button
                  variant="contained"
                  onClick={() =>
                    fetchMinimumSale(selectedDate, selectedImputation)
                  }
                  disabled={!selectedDate || !selectedImputation || loading}
                >
                  {loading ? "Consultando..." : "Consultar"}
                </Button>
                {/*  BOTÓN DE EXPORTACIÓN A PDF*/}
                {minimumSale && minimumSale.length > 0 && (
                  <Button
                    variant="contained"
                    onClick={() =>
                      exportMinimumSaleData(
                        "pdf",
                        selectedDate,
                        selectedImputation,
                        agencySelected?.number,
                      )
                    }
                    disabled={!selectedDate || !selectedImputation || loading}
                  >
                    {exporting ? <CircularProgress size={24} color="inherit" /> : "Exportar pdf"}
                  </Button>
                )}
              </Stack>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          {error ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Alert severity="error">{error}</Alert>
              <Button
                variant="outlined"
                startIcon={<ReplayIcon />}
                onClick={() =>
                  fetchMinimumSale(selectedDate, selectedImputation)
                }
                disabled={loading || !selectedDate || !selectedImputation}
              >
                Reintentar
              </Button>
            </Box>
          ) : loading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <CircularProgress size={24} color="inherit" />
              <p>Cargando datos de mínimo de ventas por terminal de juego...</p>
            </Box>
          ) : (
            <>
              <MinimumsTable
                minimums={minimumSale || []}
                message={
                  agencySelected.agencyLevel !== "CONCENTRATOR"
                    ? "❌ UD. NO TIENE ACCESO A ESTA FUNCIONALIDAD."
                    : minimumSale && minimumSale.length === 0
                      ? "No se encontraron datos para los filtros seleccionados."
                      : ""
                }
                formatCurrency={formatCurrency}
              />
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};
export default MinimumSaleTab;
